// Anonymous session management service
export class SessionService {
  constructor(tenant = 'shaqfu') {
    this.tenant = tenant;
    this.storageKey = 'sessionId';
    this.dataKey = 'sessionData';
  }

  // Generate new anonymous session ID
  generateSessionId() {
    return `anon_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  // Get or create anonymous session
  getOrCreateSession() {
    let sessionId = localStorage.getItem(this.storageKey);
    
    if (!sessionId) {
      sessionId = this.generateSessionId();
      localStorage.setItem(this.storageKey, sessionId);
      this.updateLastActive();
    }
    
    return sessionId;
  }

  // Get current session ID (without creating)
  getCurrentSessionId() {
    return localStorage.getItem(this.storageKey);
  }

  // Update last active timestamp
  updateLastActive() {
    const sessionData = this.getSessionData();
    sessionData.lastActive = new Date().toISOString();
    this.saveSessionData(sessionData);
  }

  // Get session data
  getSessionData() {
    const sessionId = this.getOrCreateSession();
    const stored = localStorage.getItem(this.dataKey);
    
    if (stored) {
      try {
        const data = JSON.parse(stored);
        return {
          sessionId,
          tenant: this.tenant,
          lastActive: new Date().toISOString(),
          ...data
        };
      } catch (error) {
        console.error('Error parsing session data:', error);
      }
    }

    // Return default session data
    return {
      sessionId,
      tenant: this.tenant,
      preferences: {},
      playlists: [],
      favorites: [],
      lastActive: new Date().toISOString()
    };
  }

  // Save session data
  saveSessionData(data) {
    const current = this.getSessionData();
    const updated = {
      ...current,
      ...data,
      lastActive: new Date().toISOString()
    };
    
    localStorage.setItem(this.dataKey, JSON.stringify(updated));
  }

  // Prepare session for migration (store for later)
  prepareForMigration() {
    const sessionId = this.getCurrentSessionId();
    if (sessionId) {
      localStorage.setItem('anonymousSessionId', sessionId);
    }
  }

  // Check if session is ready for migration
  hasPendingMigration() {
    return !!localStorage.getItem('anonymousSessionId');
  }

  // Get pending migration session ID
  getPendingMigrationId() {
    return localStorage.getItem('anonymousSessionId');
  }

  // Clear migration data after successful migration
  clearMigrationData() {
    localStorage.removeItem('anonymousSessionId');
  }
}

// Factory function
export const createSessionService = (tenant = 'shaqfu') => {
  return new SessionService(tenant);
};
